import type { Hydratable } from '@vimcar/mvvm/hydratable'

import * as dataMapper from '@vimcar/mvvm/dataMapper'
import hydratable from '@vimcar/mvvm/hydratable'
import * as mobx from 'mobx'

import type { Nodes } from '..'
import type { NodeLink } from '../NodeLink'

type _LinkGroup = {
  id: string
  title: string
  description: string
  _links: Array<{ sys: { id: string } }>
  links: Array<NodeLink>
}

// @ts-expect-error@2314
export type LinkGroup = Hydratable<_LinkGroup, object>

type Options = { nodes: Nodes }

const mkLinkGroup = hydratable(
  ({ nodes }: Options) => {
    const linkGroup = mobx.observable({
      contentModelType: 'linkGroup',
      get links() {
        // @ts-expect-error@2551
        return linkGroup._links && linkGroup._links.length
          ? // @ts-expect-error@2551
            linkGroup._links.map((link) => nodes.get(link.sys.id))
          : []
      },
    })

    return linkGroup
  },
  'LinkGroup',
  {
    fields: dataMapper.lift({
      links: '_links',
    }),
    sys: dataMapper.lift({
      id: true,
    }),
  },
)

export default mkLinkGroup
